import React from 'react'
import magnify from "../../../assets/search.svg";

export default function SearchProductPage(props) {
    const {onChange, value, placeholder} = props
  return (
    <div className="common product_search">
        <div className="input-group">
            <input
                placeholder={placeholder}
                id={props?.id}
                value={value}
                onChange={(e) => onChange(e)}
                className="form-control"
                onKeyPress={props?.onKeyPress}
            />
            <span className="input-group-text">
            <label className="search-content">
                <img src={magnify} alt="search" height="15" width="15"></img>
            </label>
            </span>
        </div>
    </div>
  )
}
